// config/entity-list-config.js
export const entityListConfig = {
  players: {
    id: 'players',
    variant: 'players',
    titleKey: 'titles.players',
    hasRepresentative: false,
    estimate: {
      field: 'estimate_players',
      minField: 'category.minimum_players',
      promptKey: () => 'params.ask_estimated_players',
      errorKey: (cat) =>
        cat === 'INTEGRA'
          ? 'errors.estimate_players_maximum'
          : 'errors.estimate_players'
    },
    columns: [
      { textKey: 'params.dni', value: 'dni', sortable: true },
      { textKey: 'params.name', value: 'name', sortable: true },
      { textKey: 'params.surname', value: 'surname', sortable: true },
      { textKey: 'params.birthday', value: 'birthday', sortable: true },
      { textKey: 'params.uniform_number', value: 'number', sortable: true },
      { textKey: 'edit', action: 'edit', class: 'edit' },
      { textKey: 'delete', action: 'delete', class: 'delete' },
      { textKey: 'titles.transfer', action: 'transfer', class: 'transfer' }
    ],
    routes: {
      view: 'player',
      edit: 'player_edit',
      removeAction: 'person/removePlayer'
    }
  },

  staff: {
    id: 'staff',
    titleKey: 'titles.staff',
    hasRepresentative: true,
    estimate: {
      field: 'estimate_staff',
      minField: null, // we'll default to 1 in code
      promptKey: () => 'params.ask_estimated_staff',
      errorKey: (cat) =>
        cat === 'INTEGRA'
          ? 'errors.estimate_staff_maximum'
          : 'errors.estimate_staff'
    },
    columns: [
      { textKey: 'params.name', value: 'name', sortable: true },
      { textKey: 'params.surname', value: 'surname', sortable: true },
      { textKey: 'params.phone', value: 'phone', sortable: false },
      { textKey: 'params.email', value: 'email', sortable: false },
      { textKey: 'edit', action: 'edit' },
      { textKey: 'delete', action: 'delete' }
    ],
    routes: {
      view: 'coach',
      edit: 'staff_edit',
      removeAction: 'person/removePerson'
    }
  },

  acompanyants: {
    id: 'acompanyants',
    titleKey: 'titles.acompanyants',
    hasRepresentative: false,
    estimate: {
      field: 'estimate_acompanyants',
      minField: null,
      promptKey: () => 'params.ask_estimated_acompanyants',
      errorKey: () => 'errors.estimate_acompanyants'
    },
    columns: [
      { textKey: 'params.name', value: 'name', sortable: true },
      { textKey: 'params.surname', value: 'surname', sortable: true },
      { textKey: 'params.birthday', value: 'birthday', sortable: true },
      { textKey: 'edit', action: 'edit' },
      { textKey: 'delete', action: 'delete' }
    ],
    routes: {
      view: 'acompanyant',
      edit: 'acompanyant_edit',
      removeAction: 'person/removePerson'
    }
  },

  responsables: {
    id: 'responsables',
    titleKey: 'titles.responsables',
    hasRepresentative: false,
    estimate: null, // no estimation UI
    columns: [
      { textKey: 'params.name', value: 'name', sortable: true },
      { textKey: 'params.surname', value: 'surname', sortable: true },
      { textKey: 'params.birthday', value: 'birthday', sortable: true },
      { textKey: 'edit', action: 'edit' },
      { textKey: 'delete', action: 'delete' }
    ],
    routes: {
      view: 'responsable',
      edit: 'responsable_edit',
      removeAction: 'person/removePerson'
    }
  },

  sanctions: {
    id: 'sanctions',
    variant: 'sanctions',
    titleKey: 'titles.sanctions',
    hasRepresentative: false,
    estimate: null,
    columns: [
      { textKey: 'params.status', value: 'status', sortable: true, width: '150px' },
      { textKey: 'params.name', value: 'name', sortable: true, width: '150px' },
      { textKey: 'params.surname', value: 'surname', sortable: true, width: '250px' },
      { textKey: 'miclive.standing.match', value: 'round_name', sortable: true, width: '100px' },
      { textKey: 'params.num_matches', value: 'num_match', sortable: true, width: '50px' },
      { textKey: 'params.num_matches_completed', value: 'matches_completed', sortable: true, width: '50px' },
      { textKey: 'params.type', value: 'type', sortable: true, width: '100px' },
      { textKey: 'punishment.', value: 'sanctions_name', sortable: true, width: '200px' }
    ],
    routes: {
      // read-only, no edit/remove
    }
  }
}
